import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.section`
  width: 100%;
  text-align: center;
  color: var(--dark);
  padding: 8px 0px 4px;
  margin-top: auto;
`

function Footer () {
  return (
    <Wrapper>
      Power by LnData, Copyright &copy; {new Date().getFullYear()}
    </Wrapper>
  )
}

export default Footer
